'use client';

import { isServer } from './ssr';
import { STORAGE_KEYS } from './storageKeys';

import type { StorageKeyType } from './storageKeys';

export type { StorageKeyType } from './storageKeys';
export { STORAGE_KEYS } from './storageKeys';

export function getStorageKey(key: StorageKeyType) {
  return `hawk-${STORAGE_KEYS[key]}`;
}

export function getStorageData(key: StorageKeyType) {
  if (isServer()) return null;
  return localStorage.getItem(getStorageKey(key));
}

export function getStorageJSONData<T>(key: StorageKeyType) {
  try {
    const saved = getStorageData(key);
    if (!saved) {
      return null;
    }

    return JSON.parse(saved) as T;
  } catch {
    return null;
  }
}

export function setStorageData(key: StorageKeyType, data: string) {
  return localStorage.setItem(getStorageKey(key), data);
}

export function setStorageJSONData<T>(key: StorageKeyType, data: T) {
  return localStorage.setItem(getStorageKey(key), JSON.stringify(data));
}

export function removeStorageData(key: StorageKeyType) {
  return localStorage.removeItem(getStorageKey(key));
}

export const deleteAllLocalStorage = () => {
  localStorage.clear();
};
